// 공지 전달 체계 「크리에이터 노출 스위치」 — app_config.creator_notice_rollout.enabled (2026-09-10 대표 지시)
//
// 2026-09-10 에 머지된 홈 알림 채널 띠·연락처 시트·「문의하기」(/support) 를 **담당 직원이 준비를 마치고 켤 때까지**
// 크리에이터에게 숨긴다. 서버 RPC `creator_notice_rollout()`(anon·로그인 모두 호출 가능)이 값을 주고,
// 어드민 `/admin/announcements` 맨 위 카드의 스위치가 `admin_set_creator_notice_rollout(boolean)` 으로 바꾼다.
//
// 🔒 규칙
//   · 실패하면 **숨김**(fail-closed). RPC 가 없거나(마이그레이션 전) 네트워크가 죽어도 띠·메뉴가 튀어나오지 않는다.
//   · 어드민(role 에 admin 포함)은 스위치와 무관하게 본다 — 켜기 전에 담당 직원이 실제 화면으로 확인하기 위해서다.
//   · 값은 세션 동안 한 번만 읽고 모듈 캐시에 둔다. 어드민이 스위치를 바꾸면 `setCreatorNoticeRolloutCache` 로 즉시 반영.
//   · 이 스위치는 「보이느냐」만 정한다. 공지 발행·승급 단계·문의 표 RLS 는 서버가 종전대로 처리한다.
//
// 훅은 src/hooks/useCreatorNoticeRollout.js — 여기는 순수 함수 + fetch 만 둔다(테스트: creatorNoticeRollout.test.js).
import { supabase } from "./supabaseClient";

export const CREATOR_NOTICE_ROLLOUT_RPC = "creator_notice_rollout";

let cache = null; // { enabled: boolean, error: string|null }
let inflight = null;

/** role 문자열에 admin 이 들어 있으면 미리보기 대상 ("Admin , Creator" 처럼 섞인 role 도 포함) */
export function isAdminRole(role) {
  return /admin/i.test(String(role || ""));
}

/** 화면에 보일지 — 스위치가 켜졌거나 어드민이면 true */
export function resolveCreatorNoticeVisible({ enabled, role }) {
  return enabled === true || isAdminRole(role);
}

/** RPC 응답 → boolean. true 일 때만 켜진 것으로 본다(문자열 "true"·1 은 false — 서버는 boolean 만 준다) */
export function normalizeRolloutValue(data) {
  return data === true;
}

export function getCreatorNoticeRolloutCache() {
  return cache;
}

export function setCreatorNoticeRolloutCache(enabled) {
  cache = { enabled: enabled === true, error: null };
  return cache;
}

/** 테스트용 */
export function resetCreatorNoticeRolloutCache() {
  cache = null;
  inflight = null;
}

/** 스위치 값을 한 번 읽는다. 실패하면 { enabled:false, error } — 절대 throw 하지 않는다 */
export function fetchCreatorNoticeRollout({ force = false } = {}) {
  if (cache && !force) return Promise.resolve(cache);
  if (inflight && !force) return inflight;
  inflight = Promise.resolve()
    .then(() => supabase.rpc(CREATOR_NOTICE_ROLLOUT_RPC))
    .then(({ data, error }) => {
      cache = error
        ? { enabled: false, error: String(error.message || error) }
        : { enabled: normalizeRolloutValue(data), error: null };
      return cache;
    })
    .catch((e) => {
      cache = { enabled: false, error: String(e?.message || e) };
      return cache;
    })
    .finally(() => {
      inflight = null;
    });
  return inflight;
}
